import { render, staticRenderFns } from "./Plexus.vue?vue&type=template&id=4a6ac9cb&scoped=true&"
import script from "./Plexus.vue?vue&type=script&lang=js&"
export * from "./Plexus.vue?vue&type=script&lang=js&"
import style0 from "./Plexus.vue?vue&type=style&index=0&id=4a6ac9cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ac9cb",
  null
  
)

export default component.exports